/* eslint-disable no-use-before-define */
/* eslint-disable no-lonely-if */
import { placeholders } from "../../../locales/placeholdersData.js";

const mobileSearchForm = document.getElementById("mobileSearchForm");
const mobileSearchInput = document.getElementById("mobileSearchInput");
const mobileSearchButton = document.getElementById("mobileSearchButton");
const mobileSearchErrorMessage = document.getElementById("mobileSearchErrorMessage");
const mobileSearchPlaceholder = document.getElementById("mobileSearchPlaceholder");
const mobileErrorIconContainer = document.getElementById("mobileErrorIconContainer");
const containerMobileFormSearch = document.querySelector(".mobile-container-form-search");

let currentMobilePlaceholderIndex = 0;
let mobilePlaceholderInterval;
let mobileTypingTimeout;

const mobileTypingSpeed = 100;
const mobileDelayBeforeNextPlaceholder = 2000;

const getMobileCurrentLanguage = () => {
  const langInput = document.querySelector('input[name="lang"]');
  if (langInput && langInput.value) {
    return langInput.value;
  }
  return "en";
};

const typeMobilePlaceholder = (text, element, callback) => {
  let i = 0;
  element.textContent = "";

  if (mobileTypingTimeout) {
    clearTimeout(mobileTypingTimeout);
  }

  const type = () => {
    if (i < text.length) {
      element.textContent += text.charAt(i);
      i++;
      mobileTypingTimeout = setTimeout(type, mobileTypingSpeed);
    } else if (callback) {
      callback();
    }
  };
  type();
};

const rotateMobilePlaceholders = () => {
  if (typeof placeholders === "undefined" || Object.keys(placeholders).length === 0) {
    return;
  }

  if (document.hidden) {
    return;
  }

  const lang = getMobileCurrentLanguage();
  const currentLanguageMobilePlaceholders = placeholders[lang] || placeholders["en"];

  if (mobileSearchInput.value.trim() !== "" || mobileSearchInput.classList.contains("error-state-mobile")) {
    if (mobileSearchPlaceholder) {
      mobileSearchPlaceholder.style.opacity = "0";
      clearInterval(mobilePlaceholderInterval);
      if (mobileTypingTimeout) {
        clearTimeout(mobileTypingTimeout);
      }
      mobileSearchPlaceholder.textContent = "";
    }
    return;
  }

  if (mobileSearchPlaceholder) {
    mobileSearchPlaceholder.classList.remove("error-placeholder-mobile");
    mobileSearchPlaceholder.style.opacity = "1";
    typeMobilePlaceholder(currentLanguageMobilePlaceholders[currentMobilePlaceholderIndex], mobileSearchPlaceholder,
      () => {
        currentMobilePlaceholderIndex = (currentMobilePlaceholderIndex + 1) % currentLanguageMobilePlaceholders.length;
      });
  }
};

const startMobilePlaceholderRotation = () => {
  if (mobilePlaceholderInterval) {
    clearInterval(mobilePlaceholderInterval);
  }
  if (mobileTypingTimeout) {
    clearTimeout(mobileTypingTimeout);
  }

  if (mobileSearchInput.classList.contains("error-state-mobile")) {
    if (mobileSearchPlaceholder) {
      mobileSearchPlaceholder.style.opacity = "0";
      mobileSearchPlaceholder.textContent = "";
    }
    return;
  }

  if (mobileSearchInput.value.trim() !== "") {
    if (mobileSearchPlaceholder) {
      mobileSearchPlaceholder.style.opacity = "0";
      mobileSearchPlaceholder.textContent = "";
    }
    return;
  }

  rotateMobilePlaceholders();
  const currentLang = getMobileCurrentLanguage();
  const currentPlaceholderTextLength =
    (placeholders[currentLang] && placeholders[currentLang][currentMobilePlaceholderIndex]?.length) || 0;

  mobilePlaceholderInterval =
    setInterval(rotateMobilePlaceholders, mobileDelayBeforeNextPlaceholder + (currentPlaceholderTextLength * mobileTypingSpeed));
};

const validateMobileSearchInput = () => {
  const query = mobileSearchInput.value.trim();
  return query.length >= 2;
};

const handleMobileVisibilityChange = () => {
  if (document.hidden) {
    if (mobilePlaceholderInterval) {
      clearInterval(mobilePlaceholderInterval);
    }
    if (mobileTypingTimeout) {
      clearTimeout(mobileTypingTimeout);
    }
  } else {
    if (mobileSearchInput.classList.contains("error-state-mobile")) {
      showMobileErrorState();
    } else if (mobileSearchInput.value.trim() === "") {
      currentMobilePlaceholderIndex = 0;
      startMobilePlaceholderRotation();
    } else {
      if (mobileSearchPlaceholder) {
        mobileSearchPlaceholder.style.opacity = "0";
        mobileSearchPlaceholder.textContent = "";
      }
    }
  }
};

const showMobileErrorState = () => {
  mobileSearchInput.classList.add("error-state-mobile");
  if (containerMobileFormSearch) {
    containerMobileFormSearch.style.borderColor = "#D9534C";
  }

  if (mobileErrorIconContainer) {
    mobileErrorIconContainer.style.display = "flex";
  }
  if (mobileSearchPlaceholder) {
    if (mobileTypingTimeout) {
      clearTimeout(mobileTypingTimeout);
    }
    clearInterval(mobilePlaceholderInterval);

    mobileSearchPlaceholder.textContent = "";
    mobileSearchPlaceholder.style.opacity = "0";
  }
  if (mobileSearchErrorMessage) {
    mobileSearchErrorMessage.style.display = "block";
    mobileSearchErrorMessage.classList.add("show");
  }
};

const hideMobileErrorState = () => {
  mobileSearchInput.classList.remove("error-state-mobile");
  if (containerMobileFormSearch) {
    containerMobileFormSearch.style.borderColor = "var(--border-container-sidebar)";
  }

  if (mobileErrorIconContainer) {
    mobileErrorIconContainer.style.display = "none";
  }
  if (mobileSearchPlaceholder) {
    mobileSearchPlaceholder.classList.remove("error-placeholder-mobile");
    mobileSearchPlaceholder.textContent = "";
  }
  if (mobileSearchErrorMessage) {
    mobileSearchErrorMessage.classList.remove("show");
    mobileSearchErrorMessage.style.display = "none";
  }

  if (mobileSearchInput.value.trim() === "") {
    startMobilePlaceholderRotation();
  }
};

if (mobileSearchForm && mobileSearchInput) {
  mobileSearchForm.addEventListener("click", () => {
    mobileSearchInput.focus();
  });
}

document.addEventListener("visibilitychange", handleMobileVisibilityChange);

if (mobileSearchButton) {
  mobileSearchButton.disabled = false;
}

if (mobileSearchInput && mobileSearchErrorMessage && mobileSearchPlaceholder) {
  mobileSearchInput.addEventListener("input", () => {
    if (mobileSearchInput.classList.contains("error-state-mobile")) {
      hideMobileErrorState();
    }

    if (mobileSearchInput.value.trim() !== "") {
      if (mobileSearchPlaceholder) {
        mobileSearchPlaceholder.style.opacity = "0";
        clearInterval(mobilePlaceholderInterval);
        if (mobileTypingTimeout) {
          clearTimeout(mobileTypingTimeout);
        }
        mobileSearchPlaceholder.textContent = "";
      }
    } else {
      startMobilePlaceholderRotation();
    }
  });

  mobileSearchInput.addEventListener("focus", () => {
    if (mobileSearchPlaceholder && !mobileSearchInput.classList.contains("error-state-mobile")) {
      mobileSearchPlaceholder.style.opacity = "0";
      clearInterval(mobilePlaceholderInterval);
      if (mobileTypingTimeout) {
        clearTimeout(mobileTypingTimeout);
      }
      mobileSearchPlaceholder.textContent = "";
    }
  });

  mobileSearchInput.addEventListener("blur", () => {
    if (mobileSearchInput.value.trim() === "" && !mobileSearchInput.classList.contains("error-state-mobile")) {
      startMobilePlaceholderRotation();
    }
  });

} else {
  console.error("Failed to attach 'input' handler for mobile. Elements are missing.");
}

if (mobileSearchForm && mobileSearchInput && mobileSearchErrorMessage && mobileSearchPlaceholder) {
  mobileSearchForm.addEventListener("submit", (event) => {
    const isValid = validateMobileSearchInput();

    if (!isValid) {
      event.preventDefault();
      showMobileErrorState();
      mobileSearchInput.focus();
    } else {
      hideMobileErrorState();
    }
  });
} else {
  console.error("Failed to attach 'submit' handler for mobile. Elements are missing.");
}

if (mobileSearchErrorMessage) {
  mobileSearchErrorMessage.style.display = "none";
}

if (mobileSearchInput && mobileSearchPlaceholder) {
  if (mobileSearchInput.value.trim() === "") {
    startMobilePlaceholderRotation();
  } else {
    mobileSearchPlaceholder.style.opacity = "0";
    mobileSearchPlaceholder.textContent = "";
  }
}
